import withCart from '../General/withCart';
import ReactTooltip from 'react-tooltip'

class ApprovedStockListLogo extends React.Component {
    isOnAsl() {
        if (this.props.product == null) {
            return false;
        }

        if (this.props.product.isApprovedStocklist) {
            return true;
        }

        if (this.props.cart != null && this.props.cart.address != null && this.props.cart.address.approvedStocklistCollection != null) {
            var stockcodeList = this.props.cart.address.approvedStocklistCollection.map((asl) => asl.lines.map((line) => line.stockcode))
            if (stockcodeList.length > 0) {
                return stockcodeList.reduce(function (a, b) { return a.concat(b); }).includes(this.props.product.stockcode);
            }
        }

        return false;
    }

    render() {
        if (this.isOnAsl()) {
            return <span className="asl-item pr-5"><i className="icon icon-approved" data-tip="Approved stocklist item"></i><ReactTooltip /></span>;
        }
        return null;
    }
}

export const ProductApprovedStockListLogo = withCart(ApprovedStockListLogo);